import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"
import CollectionSite from "./LocationModel/CollectionSite"

export interface LocationsListGetParams {
  Radius: number
  Address: string
  LabCode?: string
  IsObserved: boolean
  Codes: string[]
  IsSSO: boolean
  ReferenceTestID: number
  IsFFOrder: boolean
  AccountID?: number
  PriceTierOverride: string[]
  Latitude?: string
  Longitude?: string
}

export default function LocationsListGetObservable(params: LocationsListGetParams): Observable<CollectionSite[]> {
  const requestBody: string = JSON.stringify(params)
  return ObservableFromFetch<CollectionSite[]>("order/FindCollectionSitesV2", requestBody)
}
